// Shared image cache to avoid re-fetching images during export.
// The visible GridCanvasRenderer populates this cache when it creates <img> elements.
// The export GridCanvasRenderer reads from it to reuse in-memory bitmaps.

const imageCache = new Map(); // url -> HTMLImageElement

export function getImage(url) {
  if (imageCache.has(url)) return imageCache.get(url);
  return null;
}

export function cacheImage(url, img) {
  imageCache.set(url, img);
}

export function clearCache() {
  imageCache.clear();
}
